<template>
  <nav class="nav">
    <div class="container-fluid">
      <div class="col-xs-12">
        <ul class="nav__items row between-xs">
          <li class="nav__item col-xs"><router-link to="/">Dashboard</router-link></li>
          <li class="nav__item col-xs"><router-link to="/parameters">Parameters</router-link></li>
          <li class="nav__item col-xs"><router-link to="/batchentry">Batch Entry</router-link></li>
          <li class="nav__item col-xs"><router-link to="/results">Results</router-link></li>
          <li class="nav__item col-xs"><router-link to="/customer">Customer Info</router-link></li>
          <li class="nav__item col-xs"><router-link to="/print">Print CofA</router-link></li>
          <li class="nav__item col-xs"><router-link to="/example">Example</router-link></li>
          <li class="nav__item col-xs" v-if="showSds"><router-link to="/sdsupdate">SDS Update</router-link></li>
          <li class="nav__item col-xs" v-if="showSpec"><router-link to="/specupdate">SPEC Update </router-link></li>
          <li class="nav__item col-xs" v-if="showSds"><router-link to="/sendupdate">Send Update</router-link></li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
  export default {
    name: 'AppNavigation',

    data() {
      return {
        showSds: false,
        showSpec: false,
      };
    },

    computed: {
      shouldShowSds() {
        return this.$store.state.shouldShowSds;
      },
      shouldShowSpec() {
        return this.$store.state.shouldShowSpec;
      },
    },

    watch: {
      shouldShowSds(newValue) {
        this.syncShowSds(newValue);
      },
      shouldShowSpec(newValue) {
        this.syncShowSpec(newValue);
      },
    },

    methods: {
      syncShowSds(newValue) {
        this.showSds = newValue;
      },
      syncShowSpec(newValue) {
        this.showSpec = newValue;
      },
    },

    mounted() {
      this.syncShowSds(this.shouldShowSds);
      this.syncShowSpec(this.shouldShowSpec);
    },
  };
</script>
